import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

interface Step {
  label: string;
}

const STEPS: Step[] = [
  { label: 'Pickup Details' },
  { label: 'Review & Sign' },
];

interface PickupStepperProps {
  currentStep: number;
}

export default function PickupStepper({ currentStep }: PickupStepperProps) {
  return (
    <div className="flex items-center gap-2 mb-6">
      {STEPS.map((step, idx) => {
        const isComplete = idx < currentStep;
        const isCurrent = idx === currentStep;
        return (
          <div key={step.label} className="flex items-center gap-2">
            {idx > 0 && <div className={cn('h-px w-8', isComplete || isCurrent ? 'bg-primary' : 'bg-border')} />}
            <div className="flex items-center gap-2">
              <div
                className={cn(
                  'flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold',
                  isComplete && 'bg-primary text-primary-foreground',
                  isCurrent && 'border-2 border-primary text-primary',
                  !isComplete && !isCurrent && 'border border-border text-muted-foreground',
                )}
              >
                {isComplete ? <Check className="h-3.5 w-3.5" /> : idx + 1}
              </div>
              <span className={cn('text-sm', isCurrent ? 'font-semibold text-foreground' : 'text-muted-foreground')}>
                {step.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
